import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserRole } from '@asko/shared';
import { useAuth } from '../lib/auth';
import { useI18n } from '../lib/i18n';
import { ConfirmDialog } from './ConfirmDialog';
// Parolni o'zi almashtirish vaqtincha yopilgan (mijoz qarori,
// 26.08.2026). Kod joyida: qaytarish uchun shu uchta joyni ochish
// yetarli — import, holat va tugma.
// import { PasswordDialog } from './PasswordDialog';
import { LangSwitch } from './LangSwitch';
import { ThemeSwitch } from './ThemeSwitch';

/**
 * Umumiy sarlavha.
 *
 * Ilgari u oqim sahifasining ichida yotardi. Ma'muriyat ekrani
 * qo'shilgach ikkinchi nusxasi kerak bo'ldi — nusxa ko'chirish o'rniga
 * ajratildi: chiqish oynasi ham shu yerda, chunki u sarlavhaning
 * tugmasiga tegishli.
 */
export function AppHeader() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const { pathname } = useLocation();
  const [logoutAsked, setLogoutAsked] = useState(false);
  // const [passwordOpen, setPasswordOpen] = useState(false);

  return (
    <>
      <header className="app-header">
        <div className="app-header__brand">
          <img className="app-header__logo" src="/logo.png" alt="ASKO" />
          <span className="app-header__product">{t('app.product')}</span>

          {/* Tarix faqat ma'muriyatga: sotuvchi o'z ishini ko'radi, hammasini emas. */}
          {user?.role === UserRole.ADMIN && (
            <nav className="app-header__nav">
              <Link className={`app-header__link ${pathname === '/' ? 'is-active' : ''}`} to="/">
                {t('nav.flow')}
              </Link>
              <Link
                className={`app-header__link ${pathname.startsWith('/tarix') ? 'is-active' : ''}`}
                to="/tarix"
              >
                {t('nav.history')}
              </Link>
              <Link
                className={`app-header__link ${
                  pathname.startsWith('/foydalanuvchilar') ? 'is-active' : ''
                }`}
                to="/foydalanuvchilar"
              >
                {t('nav.users')}
              </Link>
            </nav>
          )}
        </div>

        <div className="app-header__user">
          <span className="app-header__name">
            {user?.name}
            {user?.storeName && <span className="app-header__store"> · {user.storeName}</span>}
          </span>
          <ThemeSwitch />
          <LangSwitch />
          {/*
            <button className="btn btn--ghost" onClick={() => setPasswordOpen(true)} type="button">
              {t('password.title')}
            </button>
          */}
          <button className="btn btn--ghost" onClick={() => setLogoutAsked(true)} type="button">
            {t('header.logout')}
          </button>
        </div>
      </header>

      <ConfirmDialog
        open={logoutAsked}
        title={t('logout.title')}
        body={t('logout.body')}
        confirmLabel={t('logout.confirm')}
        cancelLabel={t('common.cancel')}
        tone="danger"
        onCancel={() => setLogoutAsked(false)}
        onConfirm={() => {
          setLogoutAsked(false);
          logout();
        }}
      />

      {/* {passwordOpen && <PasswordDialog onClose={() => setPasswordOpen(false)} />} */}
    </>
  );
}
